export const PALETTE_KEY = 'palette'
